import { ResultListModel } from '@common-lib';

import { baseClient } from '../common';
import { SearchVoucherModel } from './search-voucher.model';
import { VoucherListModel } from './voucher-list.model';

const apiUrl = `/api/vouchers`;

export const voucherClient = {
  list: (
    model: SearchVoucherModel,
  ): Promise<ResultListModel<VoucherListModel>> => {
    return baseClient.body<
      SearchVoucherModel,
      ResultListModel<VoucherListModel>
    >({
      body: model,
      method: 'POST',
      url: `${apiUrl}/list`,
    });
  },
};
